/* Rondea — Filtre & Tri 100 % client (style Ruggable).
   Axes : piece / taille / couleur / matiere (OU intra-axe, ET inter-axes) + prix + tri.
   Filtre = masque/affiche les <li.rcol-card> ; tri = réordonne le DOM. Sync URL (replaceState).
   N'altère pas les data des cartes : compatible avec rondea-collection.js (swatch/popover/panier). */
(function () {
  'use strict';

  var section = document.querySelector('[data-rcol-section]');
  if (!section) return;

  /* ---------- Intro « En savoir plus » (mobile) ---------- */
  var introMore = section.querySelector('[data-intro-more]');
  var introEl = section.querySelector('[data-intro]');
  if (introMore && introEl) {
    var introTxt = introMore.querySelector('.rcol-intro__more-txt');
    introMore.addEventListener('click', function () {
      var open = introEl.classList.toggle('is-open');
      introMore.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (introTxt) introTxt.textContent = open ? 'Réduire' : 'En savoir plus';
    });
  }

  var grid = section.querySelector('[data-grid]');
  if (!grid) return;

  var AXES = ['piece', 'taille', 'couleur', 'matiere'];
  var LABELS = { piece: 'Pièce', taille: 'Taille', couleur: 'Couleur', matiere: 'Matière' };
  var cards = Array.prototype.slice.call(grid.querySelectorAll('.rcol-card'));

  // Pré-calcul des tokens par carte
  cards.forEach(function (c) {
    c._f = {};
    AXES.forEach(function (ax) {
      var raw = (c.getAttribute('data-f-' + ax) || '').toLowerCase();
      c._f[ax] = raw.split('|').filter(Boolean);
    });
    c._price = parseInt(c.getAttribute('data-price'), 10) || 0;
    c._created = parseInt(c.getAttribute('data-created'), 10) || 0;
    c._idx = parseInt(c.getAttribute('data-idx'), 10) || 0;
    c._title = c.getAttribute('data-title') || '';
    // Prix par taille : réutilise data-variants du bouton « Ajouter » ([{size, price(cents)}])
    c._priceEl = c.querySelector('[data-card-price]');
    c._priceHTML = c._priceEl ? c._priceEl.innerHTML : null;
    c._vsize = {};
    var addBtn = c.querySelector('[data-add]');
    if (addBtn) {
      try {
        JSON.parse(addBtn.getAttribute('data-variants') || '[]').forEach(function (v) {
          var m = String(v.size).match(/(\d{2,3})\s*cm/i) || String(v.size).match(/(\d{2,3})/);
          if (m && c._vsize[m[1]] == null) c._vsize[m[1]] = v.price;
        });
      } catch (e) {}
    }
  });

  // Affiche le prix de la taille filtrée (si UNE seule taille cochée), sinon « À partir de »
  function updateCardPrices(sel) {
    var single = null;
    if (sel.taille.length === 1) {
      var mm = String(sel.taille[0]).match(/(\d{2,3})/);
      single = mm ? mm[1] : null;
    }
    cards.forEach(function (c) {
      if (!c._priceEl) return;
      if (single && c._vsize[single] != null) c._priceEl.innerHTML = money2(c._vsize[single]);
      else if (c._priceHTML != null) c._priceEl.innerHTML = c._priceHTML;
    });
  }

  var filters = section.querySelector('[data-filters]');
  var pillsBox = section.querySelector('[data-pills]');
  var countEls = section.querySelectorAll('[data-count]');
  var countFoot = section.querySelector('[data-count-foot]');
  var fcountEl = section.querySelector('[data-fcount]');
  var emptyEl = section.querySelector('[data-empty]');
  var clearBtns = section.querySelectorAll('[data-clear-all]');
  var sortMain = section.querySelector('[data-sort]');
  var sortMirror = section.querySelector('[data-sort-mirror]');
  var priceWidget = section.querySelector('[data-price-widget]');

  function checkboxes() {
    return filters ? Array.prototype.slice.call(filters.querySelectorAll('input[type="checkbox"]')) : [];
  }
  function money(cents) {
    try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR', maximumFractionDigits: 0 }); }
    catch (e) { return Math.round(cents / 100) + ' €'; }
  }
  // Prix exact (2 décimales) pour l'affichage du prix d'une taille filtrée
  function money2(cents) {
    try { return (cents / 100).toLocaleString('fr-FR', { style: 'currency', currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR' }); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }

  /* ---------- Prix : double curseur ---------- */
  var price = null;
  if (priceWidget) {
    var lo = priceWidget.querySelector('[data-price-lo]');
    var hi = priceWidget.querySelector('[data-price-hi]');
    var fill = priceWidget.querySelector('[data-price-fill]');
    var loLbl = priceWidget.querySelector('[data-price-lo-lbl]');
    var hiLbl = priceWidget.querySelector('[data-price-hi-lbl]');
    var pMin = parseInt(priceWidget.getAttribute('data-min'), 10) || 0;
    var pMax = parseInt(priceWidget.getAttribute('data-max'), 10) || 0;
    price = { lo: lo, hi: hi, min: pMin, max: pMax };

    var refreshPrice = function () {
      var a = parseInt(lo.value, 10), b = parseInt(hi.value, 10);
      if (a > b - 1000) { // garde un écart minimal
        if (this === hi) { a = Math.max(pMin, b - 1000); lo.value = a; }
        else { b = Math.min(pMax, a + 1000); hi.value = b; }
      }
      var span = pMax - pMin || 1;
      var pa = ((a - pMin) / span) * 100, pb = ((b - pMin) / span) * 100;
      fill.style.left = pa + '%';
      fill.style.right = (100 - pb) + '%';
      loLbl.textContent = money(a);
      hiLbl.textContent = money(b);
    };
    lo.addEventListener('input', function () { refreshPrice.call(lo); apply(); });
    hi.addEventListener('input', function () { refreshPrice.call(hi); apply(); });
    price.refresh = refreshPrice;
    price.active = function () { return parseInt(lo.value, 10) > pMin || parseInt(hi.value, 10) < pMax; };
    refreshPrice.call(lo);
  }

  /* ---------- État courant ---------- */
  function selected() {
    var sel = { piece: [], taille: [], couleur: [], matiere: [] };
    checkboxes().forEach(function (cb) { if (cb.checked) sel[cb.name].push(cb.value); });
    // dédup (desktop + mirror éventuels)
    AXES.forEach(function (ax) { sel[ax] = sel[ax].filter(function (v, i, a) { return a.indexOf(v) === i; }); });
    return sel;
  }

  function matches(card, sel) {
    for (var i = 0; i < AXES.length; i++) {
      var ax = AXES[i], want = sel[ax];
      if (want.length) {
        var has = false, toks = card._f[ax];
        for (var j = 0; j < want.length; j++) { if (toks.indexOf(want[j]) !== -1) { has = true; break; } }
        if (!has) return false;
      }
    }
    if (price && price.active()) {
      var a = parseInt(price.lo.value, 10), b = parseInt(price.hi.value, 10);
      if (card._price < a || card._price > b) return false;
    }
    return true;
  }

  /* ---------- Tri ---------- */
  function sortValue() { return (sortMain && sortMain.value) || 'manual'; }
  function applySort() {
    var mode = sortValue();
    var arr = cards.slice();
    arr.sort(function (x, y) {
      switch (mode) {
        case 'price-asc': return x._price - y._price;
        case 'price-desc': return y._price - x._price;
        case 'created-desc': return y._created - x._created;
        case 'title-asc': return x._title.localeCompare(y._title, 'fr');
        default: return x._idx - y._idx;
      }
    });
    var frag = document.createDocumentFragment();
    arr.forEach(function (c) { frag.appendChild(c); });
    grid.appendChild(frag);
  }

  /* ---------- Pills + compteurs ---------- */
  function renderPills(sel) {
    if (!pillsBox) return;
    pillsBox.innerHTML = '';
    AXES.forEach(function (ax) {
      sel[ax].forEach(function (val) {
        var label = labelFor(ax, val);
        var pill = document.createElement('span');
        pill.className = 'rcol-pill';
        pill.innerHTML = '<span>' + LABELS[ax] + ' : ' + label + '</span>';
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.setAttribute('aria-label', 'Retirer ' + label);
        btn.innerHTML = '<svg viewBox="0 0 24 24" width="14" height="14" fill="none" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>';
        btn.addEventListener('click', function () {
          checkboxes().forEach(function (cb) { if (cb.name === ax && cb.value === val) cb.checked = false; });
          apply();
        });
        pill.appendChild(btn);
        pillsBox.appendChild(pill);
      });
    });
  }
  function labelFor(ax, val) {
    var cb = filters && filters.querySelector('input[name="' + ax + '"][value="' + cssEsc(val) + '"]');
    if (cb) {
      var l = cb.closest('.rcol-f__check').querySelector('.rcol-f__lbl');
      if (l) return l.textContent.trim();
    }
    return val;
  }
  function cssEsc(s) { return (window.CSS && CSS.escape) ? CSS.escape(s) : s.replace(/"/g, '\\"'); }

  function countActive(sel) {
    var n = 0; AXES.forEach(function (ax) { n += sel[ax].length; });
    if (price && price.active()) n += 1;
    return n;
  }

  /* ---------- Appliquer ---------- */
  function apply() {
    var sel = selected();
    var visible = 0;
    cards.forEach(function (c) {
      var ok = matches(c, sel);
      c.hidden = !ok;
      if (ok) visible++;
    });
    applySort();
    var word = visible > 1 ? ' tapis' : ' tapis';
    countEls.forEach(function (el) { el.textContent = visible + word; });
    if (countFoot) countFoot.textContent = visible;
    var nActive = countActive(sel);
    if (fcountEl) { fcountEl.hidden = nActive === 0; fcountEl.textContent = nActive; }
    clearBtns.forEach(function (b) { b.hidden = nActive === 0; });
    if (emptyEl) emptyEl.hidden = visible !== 0;
    updateCardPrices(sel);
    renderPills(sel);
    syncURL(sel);
  }

  /* ---------- URL ---------- */
  function syncURL(sel) {
    var params = new URLSearchParams();
    AXES.forEach(function (ax) { if (sel[ax].length) params.set(ax, sel[ax].join(',')); });
    if (price && price.active()) params.set('prix', parseInt(price.lo.value, 10) + '-' + parseInt(price.hi.value, 10));
    if (sortValue() !== 'manual') params.set('tri', sortValue());
    var qs = params.toString();
    history.replaceState(null, '', qs ? location.pathname + '?' + qs : location.pathname);
  }
  function readURL() {
    var p = new URLSearchParams(location.search);
    AXES.forEach(function (ax) {
      var v = p.get(ax);
      if (!v) return;
      var set = v.toLowerCase().split(',');
      checkboxes().forEach(function (cb) { if (cb.name === ax && set.indexOf(cb.value.toLowerCase()) !== -1) cb.checked = true; });
    });
    if (price && p.get('prix')) {
      var m = p.get('prix').split('-');
      if (m.length === 2) {
        price.lo.value = Math.max(price.min, parseInt(m[0], 10) || price.min);
        price.hi.value = Math.min(price.max, parseInt(m[1], 10) || price.max);
        price.refresh.call(price.lo);
      }
    }
    var tri = p.get('tri');
    if (tri) { if (sortMain) sortMain.value = tri; if (sortMirror) sortMirror.value = tri; }
  }

  /* ---------- Écouteurs ---------- */
  if (filters) filters.addEventListener('change', function (e) {
    if (e.target && e.target.matches('input[type="checkbox"]')) apply();
  });
  function bindSort(a, b) {
    if (!a) return;
    a.addEventListener('change', function () { if (b) b.value = a.value; apply(); });
  }
  bindSort(sortMain, sortMirror);
  bindSort(sortMirror, sortMain);
  clearBtns.forEach(function (b) {
    b.addEventListener('click', function () {
      checkboxes().forEach(function (cb) { cb.checked = false; });
      if (price) { price.lo.value = price.min; price.hi.value = price.max; price.refresh.call(price.lo); }
      apply();
    });
  });

  /* ---------- Tiroir mobile ---------- */
  var overlay = section.querySelector('[data-overlay]');
  function openDrawer() { if (filters) filters.classList.add('is-open'); if (overlay) overlay.hidden = false; document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (filters) filters.classList.remove('is-open'); if (overlay) overlay.hidden = true; document.body.style.overflow = ''; }
  section.querySelectorAll('[data-open-drawer]').forEach(function (b) { b.addEventListener('click', openDrawer); });
  section.querySelectorAll('[data-close-drawer]').forEach(function (b) { b.addEventListener('click', closeDrawer); });
  if (overlay) overlay.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  /* ---------- Init ---------- */
  readURL();
  apply();
})();
